export default __webpack_public_path__ + "static/media/Directory.d835201c.svg";